import { mountApp } from './ui/app';
const el = document.getElementById('app');
if (el) mountApp(el);
